import { TaskTypeField } from "../models/TaskTypeField";
import { TaskTypeDocument } from "../models/TaskTypeDocument";
import { TaskTypeCustomComponent } from "../models/TaskTypeCustomComponent";
import { ObjectTable } from "../models/ObjectTable";

export class TaskType {
    Id: number | null;
    Tenant: number;
    Name: string;
    Description: string;
    Entity: string;
    EntityTable: ObjectTable|null;
    TaskTypeFields: TaskTypeField[];
    TaskTypeDocuments: TaskTypeDocument[];
    TaskTypeCustomComponentId: number | null;
    TaskTypeCustomComponent: TaskTypeCustomComponent;
    Active: boolean;
}